/**
 * Where a notification opens. The API tags each notification with `resourceType` + `resourceId`
 * (services/api/src/routes/logic/notifications.ts); these are the NEW addresses for each kind.
 * Old addresses are not redirected (Aaron, 2026-10-11), so a notification must point here.
 *
 * Resource types the platform emits today (the four frontend/ resolved, from page manifests
 * declaring `notificationResource`): pipeline, connection, archived-record, workspace.
 * An unknown type opens nothing rather than guessing.
 */

const ROUTES: Readonly<Record<string, (id: string | null) => string | null>> = {
  pipeline: (id) => (id ? `/pipelines/${encodeURIComponent(id)}` : null),
  connection: (id) => (id ? `/systems/${encodeURIComponent(id)}` : null),
  'archived-record': (id) => (id ? `/archive/records?record=${encodeURIComponent(id)}` : null),
  workspace: () => '/settings/security',
};

export function notificationHref(resourceType: string | null, resourceId: string | null): string | null {
  if (!resourceType) return null;
  const route = ROUTES[resourceType];
  return route ? route(resourceId) : null;
}
